export const parseBoolean = (data: any, defValue: boolean): boolean => {
  try {
    return !!JSON.parse(data);
  } catch (e) {
    return defValue;
  }
};
